export {
  type OVPSessionData,
  type OVPUserInfo,
  type OVPUserSessionData,
} from './entities/auth/session'
export {
  type OVPSignInParams,
  type OVPSignUpParams,
  type OVPSignUpResponse,
  type OVPUserAuthData,
  type OVPUserAuthToken,
  type OVPUserSignInResponse,
} from './entities/auth/user'
export {
  OVPBannerType,
  type OVPBannerCarousel,
  type OVPBannerContent,
  type OVPBannerParams,
  type OVPBannerTypeContent,
  type OVPBannerTypeLiveChannel,
  type OVPBannerTypeTvShow,
  type OVPCarouselType,
} from './entities/carousels'
export { type Collection } from './entities/collections'
export {
  type Content,
  type ContentGenresToLanguages,
  type ContentLanguage,
  type ContentTag,
} from './entities/content'
export {
  type Creator,
  type CreatorAwards,
  type CreatorSocialMediaLink,
  type CreatorTag,
} from './entities/creators'
export {
  HomeRowType,
  type HomeRow,
  type HomeRowFilters,
  type HomeRows,
  type HomeRowSorting,
} from './entities/home'
export {
  type EpgInfo,
  type EpgInfoDto,
  type IProductionCountry,
  type LiveChannel,
  type LiveChannelCategory,
  type LiveChannelRegion,
  type TimeRange,
  type TvChannelWithEpg,
  type TvEpg,
  type TvEpgApiDto,
} from './entities/live'
export { type UsersPreferences } from './entities/onboarding'
export { type OtherTag } from './entities/otherTag'
export {
  type OVPPrivacyOptOut,
  type OVPPrivacySensitive,
} from './entities/privacy'
export { type OVPProfile } from './entities/profile'
export { type Search, type SearchSuggestion } from './entities/search'
export {
  type EmailCaptureConfirmParams,
  type MarketingEmailSubscribeParams,
} from './entities/seo'
export { type OVPSupport } from './entities/support'
export { type Tag } from './entities/tags'
export {
  type TvShow,
  type TvShowEpisode,
  type TvShowSeason,
  type TvShowsGenre,
  type TvShowsGenresToLanguages,
  type TvShowsLanguage,
  type TvShowsLanguages,
  type TvShowsPlaylist,
} from './entities/tvshows'
export {
  RequestCancelledError,
  RequestError,
  RequestFailedError,
  RequestHttpError,
  RequestTimeoutError,
} from './errors'
export type { HttpErrorResponse } from './errors'
export type { HttpRequestInfo, HttpResponseInfo } from './events/http'
export { type LogicError } from './events/logic'
export {
  ContentTypeDefault,
  type Adapter,
  type API,
  type ContentType,
  type Headers,
  type SeoMetadata,
} from './index.h'
export {
  AnalyticsContentType,
  AnalyticsPathEnum,
  FullscreenTypeEnum,
  PlaybackTriggerEnum,
  PlayerEventTypeOVP,
  type AnalyticsGenericInfoOVP,
  type AnalyticsInfoOVP,
  type AnalyticsPlayerOpenInfoOVP,
  type AnalyticsPromoInstallAppBannerStoreDestination,
  type AnalyticsSearchInfoOVP,
  type ApplicationInfoOVP,
  type BEAnalyticsInfoOVP,
  type IContentInfoOVP,
  type IEpgCategoryInfoOVP,
  type IEpgChannelInfoOVP,
  type IEpgInfoOVP,
  type IEpgProgramInfoOVP,
  type ISearchInfoOVP,
  type IUTMParams,
  type VideoSourceInfoOVP,
} from './interfaces/analytics_ovp'
export {
  MediaTypes,
  type ApiCommonResponse,
  type GenericApiResponse,
} from './interfaces/generic'

import { type Adapter } from './index.h'

import * as events from './events'

import * as userSession from './entities/auth/session'
import * as user from './entities/auth/user'
import * as carousels from './entities/carousels'
import * as channelOwners from './entities/channelOwners'
import * as collections from './entities/collections'
import * as content from './entities/content'
import * as creators from './entities/creators'
import * as home from './entities/home'
import * as live from './entities/live'
import * as onboarding from './entities/onboarding'
import * as otherTag from './entities/otherTag'
import * as privacy from './entities/privacy'
import * as profile from './entities/profile'
import * as users from './entities/profile/users'
import * as search from './entities/search'
import * as seo from './entities/seo'
import * as support from './entities/support'
import * as tags from './entities/tags'
import * as tvshows from './entities/tvshows'

export const version: string = '__VERSION__'

/**
 * Singleton with API layer,
 * provides events/effects/stores to communicate with backend
 */
export const api = {
  use(adapter: Adapter) {
    adapter(this)
  },

  events,

  carousels,
  collections,
  tags,
  content,
  creators,
  search,
  user,
  userSession,
  profile,
  users,
  onboarding,
  privacy,
  support,
  channelOwners,
  home,
  otherTag,
  live,
  tvshows,
  seo,
} as const
